function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1726_5144)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.2782 76.0818C60.887 76.0818 76.783 60.1858 76.783 40.577C76.783 20.9683 60.887 5.07227 41.2782 5.07227C21.6695 5.07227 5.77344 20.9683 5.77344 40.577C5.77344 60.1858 21.6695 76.0818 41.2782 76.0818Z",
  fill: "#FFC84D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.7113 36.4561C34.0576 36.4561 35.9597 33.9781 35.9597 30.9214C35.9597 27.8647 34.0576 25.3867 31.7113 25.3867C29.365 25.3867 27.4629 27.8647 27.4629 30.9214C27.4629 33.9781 29.365 36.4561 31.7113 36.4561Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.8441 36.4561C53.1904 36.4561 55.0925 33.9781 55.0925 30.9214C55.0925 27.8647 53.1904 25.3867 50.8441 25.3867C48.4978 25.3867 46.5957 27.8647 46.5957 30.9214C46.5957 33.9781 48.4978 36.4561 50.8441 36.4561Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.2792 63.556C46.0749 63.556 49.9626 58.6573 49.9626 52.6144C49.9626 46.5716 46.0749 41.6729 41.2792 41.6729C36.4834 41.6729 32.5957 46.5716 32.5957 52.6144C32.5957 58.6573 36.4834 63.556 41.2792 63.556Z",
  fill: "#FF6D00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.8625 45.554C46.2699 43.1985 43.9286 41.6729 41.2789 41.6729C38.6292 41.6729 36.288 43.1985 34.6953 45.554H47.8605H47.8625Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1726_5144"
}, /*#__PURE__*/React.createElement("rect", {
  width: 81.1538,
  height: 81.1538,
  fill: "white",
  transform: "translate(0.701172)"
})));

function SvgSmilesvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilesvg);
export default __webpack_public_path__ + "static/media/smilesvg.eaa86fe8.svg";
export { ForwardRef as ReactComponent };